// MUTATIONS
export const MUTATION_SET_DEVELOPER_ACCESS                      = 'setDeveloperAccess'
export const MUTATION_SET_LOADED                      = 'setLoaded'
export const MUTATION_SET_LOADING                      = 'setLoading'
export const MUTATION_SET_USER_NAME               = 'setUserName'
export const MUTATION_SET_META_DATA                   = 'setMetaData'

// ACTIONS
export const ACTION_LOAD_PREFERENCES                  = 'loadUserPreferences'
